import React from 'react'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { Table, TableBody, TableCell, TableHead, TableHeadCell, TableRow, Button } from "flowbite-react";
import { PencilSquareIcon, ArrowUpTrayIcon, ListBulletIcon , TrashIcon} from '@heroicons/react/24/outline'
import Modals from '../../components/Modal'
import FormRole from './FormRole';
import PermissionList from './PermissionList';
import AreaList from './AreaList';
import LoadingSpinner from '../../components/LoadingSpinner';

const Role = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const closeModal = () => setIsModalOpen(false);
    const [modalTitle, setModalTitle] = useState("");
    const [roleId, setRoleId] = useState(null);
    const [roles, setRoles] = useState([]);
    const [error, setError] = useState(null);
    const [isCreating, setIsCreating] = useState(false);
    const [modalType, setModalType] = useState('role');
    const [isLoading, setIsLoading] = useState(false);

    

    const openModal = (title,rolId,editMode) => {
        setModalTitle(title);
        setIsModalOpen(true);
        setRoleId(rolId);
        setIsCreating(editMode);
        if(title=="Permisos"){
            setModalType('permission');
        }else if(title=="Areas"){
            setModalType('area');
        }else{
            setModalType('role');
        }
    };
    const handleFormSubmit = async(data) => {
        
        let name = data.name == "";
        if(name){ alert("Ingrese el rol"); return;}

        let description = data.description == "";
        if(description){ alert("Ingrese la descripción"); return;}

        let status = data.status == "";
        if(status){ alert("Seleccione el estado"); return;}

        setIsLoading(true);
        try {
            const response = await axios.post(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/role/create`,
                data,
                {
                    withCredentials: true,
                }
            );
            setRoles([...roles, response.data.new_role]);
        } catch (error) {
            
        } finally{
            setIsLoading(false);
        }

        closeModal(); 
    };

    const handleFormUpdate = async(data) => {
        setIsLoading(true);
        try {
            const response2 = await axios.put(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/role/${roleId}/update`,
                data,
                {
                    withCredentials: true,
                }
            );

            console.log("roleId",roleId);
            setRoles(
                roles.map((role) =>
                    role.id === roleId ? { ...roles, ...response2.data.rol } : role
                )
            ); 
        } catch (error) {
            
        } finally{
            setIsLoading(false);
        }

        closeModal(); 
    }

    const handleRemove = async (id) => {
        const confirma = confirm('confirma la eliminación del rol?');
        if (!confirma) return;
        setIsLoading(true);
        try{
            const response = await axios.delete(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/role/${id}/delete`,
                {
                    withCredentials: true,
                }
            );
            if (response.statusText !== "OK") {
                throw new Error(response.message || 'Error en la obtención de datos');
            }
            setRoles(roles.filter((rol) => rol.id !== id));

        }catch(error){
            
        }finally{
            setIsLoading(false);
        }
    }

    useEffect(()=>{
        const getRoles = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get( 
                    `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/roles`,
                    {
                        withCredentials: true,
                    }
                );

                if (response.statusText !== "OK") {
                    throw new Error(response.message || 'Error en la obtención de datos');
                }

                setRoles(response.data);
            } catch (error) {
                setError(error.message);
            } finally{
                setIsLoading(false);
            }
        }
        getRoles();
    },[]);

    return (
        <>
            {isLoading && <LoadingSpinner message="Procesando..." size="lg" color="blue"/>}
            <div className="p-2 mt-4 flex justify-between">
                <h1 className="text-xl mb-2 px-3 flex-col">Roles</h1>
                <div className="flex justify-end">
                    <Button className="text-gray-600" onClick={()=>openModal("Roles",null,true)} color='gray'>Crear</Button>
                </div>
                {error && <div className="text-red-500">{error}</div>}
            </div>
            <div className="overflow-x-auto">
                <Table>
                    <TableHead>
                        <TableHeadCell className="text-left">Rol</TableHeadCell>
                        <TableHeadCell className="text-left">Estado</TableHeadCell>
                        <TableHeadCell>
                            <span className="srOnly">Acción</span>
                        </TableHeadCell>
                    </TableHead>
                    <TableBody className="divide-y">
                        {roles.map((rol) => (
                            <TableRow key={rol.id} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                                <TableCell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                                    {rol.name}
                                </TableCell>
                                <TableCell>{(parseInt(rol.status)===1)?'Activo':'Inactivo'}</TableCell>
                                <TableCell className="inline-flex">
                                    <a href="#" onClick={()=>openModal("Areas",rol.id, false)}>
                                        <ArrowUpTrayIcon className="w-5 text-blue-500 mr-3" title="Asignar áreas"/>
                                    </a>
                                    <a href="#" onClick={()=>openModal("Permisos",rol.id, false)}>
                                        <ListBulletIcon className="w-5 text-blue-500 mr-3" title="Asignar permisos"/>
                                    </a>
                                    <a href="#" onClick={()=>openModal("Roles",rol.id, false)}>
                                        <PencilSquareIcon className="w-5 text-blue-500 mr-3" title="Editar rol"/>
                                    </a>
                                    <a href="#" onClick={()=>handleRemove(rol.id)}>
                                        <TrashIcon className="w-5 text-blue-500 mr-3" title="Eliminar rol"/>
                                    </a>

                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        
            { modalType === 'role' && 
                <Modals isOpen={isModalOpen} onClose={closeModal} title={modalTitle} modalSize={"md"}>
                    <FormRole onSubmit={isCreating ? handleFormSubmit : handleFormUpdate} onClose={closeModal} roleId={roleId} /> 
                </Modals>
            }
            { modalType === 'permission' && 
            <Modals isOpen={isModalOpen} onClose={closeModal} title={modalTitle} modalSize={"xl"}>
                <PermissionList onClose={closeModal} roleId={roleId} /> 
            </Modals>
            }
            { modalType === 'area' && 
            <Modals isOpen={isModalOpen} onClose={closeModal} title={modalTitle} modalSize={"xl"}>
                <AreaList onClose={closeModal} roleId={roleId} /> 
            </Modals>
            }

        </>
  )
}

export default Role
